export default {
  default: {
    forms: 'Forms',
    responses: 'Responses',
    title: 'Stats',
  },
}
